import React, {
    useContext, useCallback, useState, useMemo
} from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { ModalNextProvider, Loader } from '@jutro/components';
import { messages as commonMessages } from 'gw-platform-translations';
import { PolicyChangeService } from 'gw-capability-gateway';
import metadata from './UnderwritingIssues.metadata.json5';
import styles from './UnderwritingIssues.module.scss';
import messages from './UnderwritingIssues.messages';
//import LoadSaveService from '../../../../../../../common/capabilities/gw-capability-quoteandbind/services/LoadSaveService';

const BLOCKS_QUOTES = ['BlocksQuote', 'BlocksQuoteRelease'];
const BLOCKS_BIND = 'BlocksBind';
const NON_BLOCKING = 'NonBlocking';

const DisplayUnderwritingIssues = (props) => {
    const {
        underwritingIssues,
        blockQuote,
        history,
        quoteID,
        filterUWIssuesInCustomOffering,
        job,
        noteForUW,
        futureRenewalAvailable,
        submissionVM,
        updateWizardData,
        referButtonVisible
    } = props;
    const [referToUWForm, setReferToUWForm] = useState(false);
    const [underwriterButton, setUnderwriterButton] = useState(true);
    const [withdrawButton, setWithdrawButton] = useState(true);
    const [formData, updateFormData] = useState({});
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const { quoteUnderWritingService } = useDependencies('quoteUnderWritingService');
    const [defaultNoteValue, setDefaultNoteValue] = useState(false);
    const { LoadSaveService } = useDependencies('LoadSaveService');


    const UWNoteMessageCal = () => {
        if (job.code) {
            if (job.code == 'PolicyChange') {
                return (
                    <b>
                        {translator(messages.policyChangeNoteInfoUW)}
                    </b>
                );
            } if (job.code == 'Submission') {
                return (
                    <b>
                        {translator(messages.submissionNoteInfoUW)}
                    </b>
                );
            }
        } else {
            return null;
        }
    };

    // const changeNoteForUW = (value, path) => {
    //     const nextFormData = _.cloneDeep(formData);
    //     _.set(nextFormData, path, value);
    //     updateFormData(nextFormData);
    // };


    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
        },
        [formData]
    );

    const getUwIssuesByGroup = useMemo(() => {
        const blockingUWIssues = underwritingIssues.filter(
            (issue) => issue.currentBlockingPoint !== NON_BLOCKING
        );
        return _.groupBy(blockingUWIssues, (issue) => issue.offering);
    }, [underwritingIssues]);

    const displayableIssues = useMemo(() => {
        let issues = _.keys(getUwIssuesByGroup);
        if (filterUWIssuesInCustomOffering) {
            issues = issues.filter((val) => val !== 'CUSTOM');
        }
        return issues.sort();
    }, [filterUWIssuesInCustomOffering, getUwIssuesByGroup]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const showPopUp = async () => {
        ModalNextProvider.showConfirm({
            title: messages.brokerDeclaration,
            message: messages.confirmationOfSignAndDoc,
            status: 'success',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,
            cancelButtonText: commonMessages.no
        }).then(async (results) => {
            if (results === 'cancel') {
                setReferToUWForm(false);
                setUnderwriterButton(true);
                setWithdrawButton(true);
                updateFormData({});
            } else if (noteForUW) {
                setDefaultNoteValue(true);
            }
        });
    };

    const openUWForm = useCallback(() => {
        showPopUp();
        setReferToUWForm(true);
        setUnderwriterButton(false);
        setWithdrawButton(false);
    }, [showPopUp]);

    const referToUnderwriter = useCallback(() => {
        if (!quoteUnderWritingService) {
            return;
        }
        const { notes, applyChangesToRenewalTrans } = formData;
        const {submissionVM} = props;

        if(submissionVM && submissionVM.value){ 
            if (submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value === undefined || submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value == ''){
                ModalNextProvider.showAlert({
                    title: messages.modelError,
                    message: messages.payUsingBAError,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                return false;
            } else {
            LoadSaveService.updateQuotedSubmissionWithPaymentData(submissionVM.value, authHeader)
                .then((response) => {
                    _.set(submissionVM, 'bindData.paymentDetails', response.bindData.paymentDetails);
                    updateWizardData(submissionVM);
                })
            }
        }

        if (job.code === 'PolicyChange') {
            PolicyChangeService.referToUnderwriter(quoteID, notes, applyChangesToRenewalTrans, authHeader).then(() => {
                history.push(`/change/${quoteID}/summary`);
            });
        } else {
            quoteUnderWritingService.referToUnderwriter(quoteID, notes, authHeader).then(() => {
                history.push(`/quotes/${quoteID}/summary`);
            });
        }
    }, [quoteUnderWritingService, formData, job.code, quoteID, authHeader, history]);

    const ACTION_MSG = {
        cancelAction: {
            title: commonMessages.wantTowithDraw,
            message: commonMessages.wantTowithDrawConf,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yes,
            cancelButtonText: commonMessages.close
        }
    };

    const withdrawHandler = useCallback(() => {
        if (!quoteUnderWritingService) {
            return;
        }
        ModalNextProvider.showConfirm(ACTION_MSG.cancelAction).then((results) => {
            if (results === 'cancel') {
                return _.noop();
            }
            quoteUnderWritingService.withdrawJobByJobNumber(quoteID, authHeader).then(() => {
                history.push(`/quotes/${quoteID}/summary`);
            });
        }, _.noop);
    }, [quoteUnderWritingService, ACTION_MSG.cancelAction, quoteID, authHeader, history]);

    const cancelButton = useCallback(() => {
        setReferToUWForm(false);
        setUnderwriterButton(true);
        setWithdrawButton(true);
        updateFormData({});
    }, []);

    const getBlockingPointDisplayKey = useCallback(
        (blockingPoint) => {
            switch (blockingPoint) {
                case 'BlocksBind':
                    return translator(messages.blocksBind);
                case 'BlocksQuote':
                    return translator(messages.blocksQuote);
                case 'BlocksQuoteRelease':
                    return translator(messages.blocksQuoteRelease);
                case 'NonBlocking':
                    return translator(messages.nonBlocking);
                default:
                    return blockingPoint;
            }
        },
        [translator]
    );

    const approveQuote = useCallback(
        (evt, DTO) => {
            evt.preventDefault();
            if (!quoteUnderWritingService) {
                return;
            }
            quoteUnderWritingService.approveUnderwritingIssue(quoteID, DTO, authHeader);
        },
        [quoteUnderWritingService, quoteID, authHeader]
    );

    const generateIssuesData = useCallback(
        (offering) => {
            const getUwIssueByBindOrBlock = !blockQuote
                ? offering.filter((issue) => issue.currentBlockingPoint === BLOCKS_BIND)
                : offering.filter((issue) => BLOCKS_QUOTES.includes(issue.currentBlockingPoint));
            return getUwIssueByBindOrBlock.map((issue) => {
                const currentBlockingPoint = getBlockingPointDisplayKey(issue.currentBlockingPoint);
                return (
                    <tr>
                        <td>{issue.description}</td>
                        <td>{currentBlockingPoint}</td>
                        {issue.canUserApprove ? (
                            <>
                                <td>
                                    <a
                                        href
                                        onClick={(evt) => approveQuote(evt, issue.originalDTO)}
                                    >
                                        {translator(messages.approve)}
                                    </a>
                                </td>
                            </>
                        ) : null}
                    </tr>
                );
            });
        },
        [translator, approveQuote, blockQuote, getBlockingPointDisplayKey]
    );

    const underWritingIssuesTable = useCallback(() => {
        const renderByBlockingPoint = displayableIssues;
        return (
            <table>
                {renderByBlockingPoint.map((offering) => {
                    return (
                        <>
                            {generateIssuesData(getUwIssuesByGroup[offering])}
                        </>
                    );
                })}
            </table>
        );
    }, [generateIssuesData, displayableIssues, getUwIssuesByGroup]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            openUWForm,
            referToUnderwriter,
            cancelButton,
            withdrawHandler
        }
    };
    const overrideProps = {
        gwAlert: {
            visible: blockQuote || displayableIssues.length > 0
        },
        gwAlertHeading: {
            content: translator(messages[blockQuote ? 'weCannotShow' : 'followingQuotes'])
        },
        alertAffectedQuotes: {
            visible: !blockQuote,
            content: displayableIssues.join(',')
        },
        referToUWForm: {
            visible: referToUWForm
        },
        underwriterButton: {
            visible: underwriterButton,
            disabled: (referButtonVisible !== undefined && referButtonVisible)
        },
        cancelButton: {
            visible: cancelButton
        },
        withdrawButton: {
            visible: withdrawButton
        },
        issuesTable: {
            content: underWritingIssuesTable()
        },
        noteInfoTextByJob: {
            content: UWNoteMessageCal()
        },
        referToUnderwriter: {
            disabled: !formData.notes
                || (job.code === 'PolicyChange'
                && ((futureRenewalAvailable === undefined && formData.applyChangesToRenewalTrans !== undefined)
                || (futureRenewalAvailable !== undefined && futureRenewalAvailable && formData.applyChangesToRenewalTrans === undefined)))
        },
        UWFormInput: {
            defaultValue: noteForUW
        },
        applyChangesToRenewalTrans_EY: {
            visible: job.code === 'PolicyChange' && futureRenewalAvailable !== undefined && futureRenewalAvailable
        },
        prequthorisedPaymentAlertInfo: {
            visible: submissionVM != undefined ? (submissionVM.bindData && submissionVM.bindData.paymentDetails.paymentMethod 
                    && (submissionVM.bindData.paymentDetails.paymentMethod.value == "Preauthorized Bank Account"
                    || submissionVM.bindData.paymentDetails.paymentMethod.value == "Preauthorized Credit Card")) : false
        }
        
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={formData}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
};

DisplayUnderwritingIssues.propTypes = {
    underwritingIssues: PropTypes.arrayOf({}),
    blockQuote: PropTypes.bool,
    quoteID: PropTypes.string.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    filterUWIssuesInCustomOffering: PropTypes.bool,
    noteForUW: PropTypes.string
};
DisplayUnderwritingIssues.defaultProps = {
    underwritingIssues: [],
    blockQuote: false,
    filterUWIssuesInCustomOffering: true,
    noteForUW: ''
};

const UnderwritingIssues = (props) => {
    const { underwritingIssues } = props;
    const hasUwIssues = underwritingIssues.length;
    const getOnOfferings = useMemo(() => {
        return underwritingIssues.every((uwIssue) => {
            return NON_BLOCKING.includes(uwIssue.currentBlockingPoint);
        });
    }, [underwritingIssues]);

    // render DisplayUnderwritingIssues only when underwritingIssues are available.
    return hasUwIssues && !getOnOfferings ? <DisplayUnderwritingIssues {...props} /> : null;
};

UnderwritingIssues.propTypes = {
    underwritingIssues: PropTypes.arrayOf({}).isRequired,
    quoteID: PropTypes.string.isRequired,
    filterUWIssuesInCustomOffering: PropTypes.bool
};

UnderwritingIssues.defaultProps = {
    filterUWIssuesInCustomOffering: true
};

export default withRouter(UnderwritingIssues);
